var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.5V11.5H9.96667V5.5H5.5ZM5 4C4.44772 4 4 4.44772 4 5V12C4 12.5523 4.44772 13 5 13H10.4667C11.019 13 11.4667 12.5523 11.4667 12V5C11.4667 4.44772 11.019 4 10.4667 4H5Z",
    fill: "#314361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 12.5V18.5H14.0333V12.5H18.5ZM19 11C19.5523 11 20 11.4477 20 12V19C20 19.5523 19.5523 20 19 20H13.5333C12.981 20 12.5333 19.5523 12.5333 19V12C12.5333 11.4477 12.981 11 13.5333 11H19Z",
    fill: "#314361"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0332 5.5V8.5H18.4999V5.5H14.0332ZM13.5332 4C12.9809 4 12.5332 4.44772 12.5332 5V9C12.5332 9.55228 12.9809 10 13.5332 10H18.9999C19.5522 10 19.9999 9.55228 19.9999 9V5C19.9999 4.44772 19.5522 4 18.9999 4H13.5332Z",
    fill: "#314361"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9668 15.5V18.5H5.50013V15.5H9.9668ZM10.4668 14C11.0191 14 11.4668 14.4477 11.4668 15V19C11.4668 19.5523 11.0191 20 10.4668 20H5.00013C4.44785 20 4.00013 19.5523 4.00013 19V15C4.00013 14.4477 4.44785 14 5.00013 14H10.4668Z",
    fill: "#314361"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c3ecd6df3649f696d9efd3c1c6bafe61.svg";
export { ForwardRef as ReactComponent };